import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Leaf, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9] px-6 noise-overlay">
      <div className="w-full max-w-sm animate-fade-in-up">
        <div className="flex items-center gap-2 mb-10">
          <div className="w-9 h-9 rounded-sm bg-brand flex items-center justify-center"><Leaf className="text-white" size={18} strokeWidth={1.5} /></div>
          <span className="font-serif text-2xl text-stone-900 tracking-tight">Q<span className="text-brand">COST</span></span>
        </div>
        {sent ? (
          <div data-testid="forgot-sent">
            <MailCheck size={40} className="text-brand mb-4" />
            <h1 className="font-serif text-4xl font-light text-stone-900 mb-2">Controlla la tua email</h1>
            <p className="text-sm text-stone-500 mb-8">Se esiste un account con questa email, ti abbiamo inviato un link per reimpostare la password (valido 1 ora).</p>
            <button data-testid="back-to-login" onClick={() => navigate("/login")} className="text-brand font-semibold hover:underline flex items-center gap-2"><ArrowLeft size={16} /> Torna al login</button>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-4xl sm:text-5xl font-light text-stone-900 mb-2">Password dimenticata?</h1>
            <p className="text-sm text-stone-500 mb-10">Inserisci la tua email: ti invieremo un link per reimpostare la password.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Email</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full border border-stone-300 bg-white px-4 py-3 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40 transition-colors" placeholder="nome@ristorante.it" />
              </div>
              {error && <p data-testid="forgot-error" className="text-sm text-alert">{error}</p>}
              <button data-testid="forgot-submit-btn" disabled={loading}
                className="w-full rounded-full bg-brand text-white py-3.5 text-sm font-semibold hover:bg-brand-hover transition-colors disabled:opacity-60">
                {loading ? "Invio…" : "Invia link di reset"}
              </button>
            </form>
            <button data-testid="back-to-login" onClick={() => navigate("/login")} className="mt-8 text-sm text-brand font-semibold hover:underline flex items-center gap-2"><ArrowLeft size={16} /> Torna al login</button>
          </>
        )}
      </div>
    </div>
  );
}
